import React from 'react'
import { usePostRequest } from '../hooks/request'
import { BALANCE_ITEM_LIST } from '../urls'
import BalanceItemForm from './BalanceItemForm'

export default function BalanceItemCreate({ onCancel, onSuccess, finance, rotationId }) {
    const monthCreate = usePostRequest({ url: BALANCE_ITEM_LIST.replace('{balanceId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <BalanceItemForm
                finance={finance}
                rotationId={rotationId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
